<template>
  <v-container>
    <v-btn
      color="#4d48f9"
      @click="routePanelUserAdd()"
      v-if="isAdmin"
      style="text-transform: none !important; color: white;"
    >
      YENİ KULLANICI EKLE
    </v-btn>
    <br />
    <br />
    <v-card>
      <v-card-title>
        Panel Kullanıcıları
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="allPanelUsers"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.role="{ item }">
          {{ allRoles.find((x) => x.id == item.role).name }}
        </template>
        <template v-slot:item.active="{ item }">
          <v-checkbox
            v-model="item.active"
            :disabled="!isAdmin || email == item.email"
            color="#4d48f9"
            @change="userStatusChange(item)"
          ></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            :disabled="!isAdmin"
            @click="routePanelUserEdit(item)"
          >
            mdi-pencil
          </v-icon>
          <!-- <v-icon small @click="onBoardingDelete(item)">mdi-delete</v-icon> -->
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="userPageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PanelUsers',
  data: () => ({
    search: '',
    isAdmin: false,
    email: '',
    userPageData: {
      pageNumber: 1,
      pageSize: 10,
      search: '',
    },
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    headers: [
      {
        text: 'Ad',
        align: 'start',
        // sortable: false,
        value: 'firstName',
      },
      { text: 'Soyad', value: 'lastName' },
      { text: 'Mail adresi', value: 'email' },
      { text: 'Rol', value: 'role' },
      { text: 'Firma', value: 'companyName' },
      { text: 'Mağaza', value: 'venueName' },
      { text: 'Aktif/Pasif', value: 'active' },
      { text: 'Detay', value: 'actions', sortable: false },
    ],
    allRoles: [
      {
        id: 'PanelUser',
        name: 'Admin',
      },
      {
        id: 'PanelVenueUser',
        name: 'Üye İş Yerleri',
      },
      {
        id: 'PanelReportUser',
        name: 'Rapor Erişimi',
      },
      {
        id: 'AppliedMerchantUser',
        name: 'Başvuru Yapılmış',
      },
    ],
  }),
  computed: mapGetters(['allPanelUsers', 'loading']),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1
    this.userPageData.pageNumber = Number(page)

    this.getPanelUsers(this.userPageData).then((response) => {
      this.pagination.totalItems = response.totalCount
      this.pagination.pagesLength = response.totalPages
    })
    this.userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.email = localStorage.getItem('email')
    console.log('email', this.email)

    if (
      this.userRoles.find((x) => x == 'PanelUser') != null &&
      this.userRoles.find((x) => x == 'PanelUser') != undefined
    ) {
      this.isAdmin = true
      console.log('admin', this.isAdmin)
    }
  },
  methods: {
    ...mapActions([
      'getPanelUsers',
      'getCompanieList',
      'getVenues',
      'putUpdateUserStatus',
    ]),

    routePanelUserDetail(user) {
      console.log('user', user)
    },

    // Data table item per page changed function
    getItemPerPage(val) {
      this.userPageData.pageSize = val
      this.userPageData.pageNumber = 1

      this.getPanelUsers(this.userPageData)
        .then((response) => {
          this.pagination.pagesLength = response.totalPages
          return this.getCompanieList()
        })
        .then((response) => {
          return this.getVenues(this.userPageData.companyId)
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    },

    getPageNumber(val) {
      this.userPageData.pageNumber = val
      if (val !== 1) {
        this.$router.push({ query: { page: val } })
      }
      this.getPanelUsers(this.userPageData)
    },

    setPageNumber(val) {
      if (
        (!this.$route.query.page && val === 1) ||
        this.$route.query.page == val
      ) {
        return
      }
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },

    getItemPerSearch(val) {
      this.userPageData.pageNumber = 1
      this.userPageData.search = val
      this.getPanelUsers(this.userPageData)
        .then((response) => {
          this.pagination.totalItems = response.totalCount
          this.pagination.pagesLength = response.totalPages
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    },

    // UserStatus
    userStatusChange(user) {
      console.log('userStatus', user)
      this.putUpdateUserStatus(user)
        .then((response) => {
          console.log('response', response)
          if (response.processStatus === 'Success') {
            alert('Başarıyla güncellendi.')
          } else {
            alert(response.friendlyMessage.message)
          }
        })
        .catch((error) => {
          console.error('Error updating user status:', error)
        })
    },

    // UserAdd
    routePanelUserAdd() {
      this.$router.push('panelUser')
    },

    // UserEdit
    routePanelUserEdit(item) {
      console.log('item', item)
      this.$router.push(`panelUser/${item.id}`)
    },

    processUrlChange(to) {
      console.log('fullpath : ' + to.fullPath)
      if (to.fullPath.split('=').length >= 2) {
        this.getPageNumber(to.query.page)
      } else if (to.fullPath === '/dashboard/users/panelUsers') {
        this.getPageNumber(1)
      }
    },
  },

  watch: {
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 2) return
      this.getItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
}
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}
.v-data-footer__icons-after {
  display: none;
}
</style>
